import { FormControl } from '@angular/forms';
import { CHANNEL_TYPE } from '../../enum/constants';

export interface IWriteMessageForm {
  channel_id: FormControl<string | null>;
  chat_name: FormControl<string | null>;

  phone?: FormControl<string | null>;
  username?: FormControl<string | null>;
}

export const SEND_MESSAGE_CHANNEL_TYPES: CHANNEL_TYPE[] = [
  CHANNEL_TYPE.TELEGRAM,
  CHANNEL_TYPE.VIBER,
];

export const PHONE_FIELD_CHANNEL_TYPES: CHANNEL_TYPE[] = [
  CHANNEL_TYPE.TELEGRAM,
  CHANNEL_TYPE.VIBER,
];

export const USERNAME_FIELD_CHANNEL_TYPES: CHANNEL_TYPE[] = [
  CHANNEL_TYPE.TELEGRAM,
];

export const REQUIRED_ALL_FIELDS_CHANNEL_TYPES: CHANNEL_TYPE[] = [
  CHANNEL_TYPE.VIBER,
];

export const SOME_FIELD_REQUIRED_CHANNEL_TYPES: CHANNEL_TYPE[] = [
  CHANNEL_TYPE.TELEGRAM,
];

export interface CreateChatForMessagePayload {
  channel_id: string;
  chat_name: string;
  phone?: string;
  username?: string;
}
